<div class="faq__search">
  <div class="faq__search__body">
    <!-- <ng-container *ngIf="faqBodies?.length">
      <p class="faq__no-results">{{'faq.back-to' | i18next}} <a [routerLink]="['faq' | routeTranslate]"
           (click)="onNoResultClick()">{{'faq.back-to.link' |
          translate}}<sharry-icon registryName="caret-right"
                       svgClass="link-caret">
          </sharry-icon></a></p>
    </ng-container> -->
    <mat-accordion>
      @for (f of faqBodies | slice: index * pageSize : index * pageSize + pageSize; track f.id) {
        <mat-expansion-panel [expanded]="f.expanded">
          <mat-expansion-panel-header>
            <mat-panel-title class="faq__search__title">
              <small class="faq__hero__tag bold"
                >{{ f.faqSection?.faq?.title }} &bullet; {{ f.faqSection?.title }}</small
              >
              <p class="semibold">{{ f.title }}</p>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div
            class="faq__inner"
            [innerHTML]="f.body"></div>
        </mat-expansion-panel>
      }
    </mat-accordion>
    @if (!faqBodies?.length) {
      <p class="faq__no-results">
        {{ 'faq-search.pre' | i18next }}
        <a
          [routerLink]="['faq' | routeTranslate]"
          (click)="onNoResultClick()"
          >{{ 'faq-search.link' | i18next }}
          <sharry-icon
            registryName="caret-right"
            svgClass="link-caret">
          </sharry-icon> </a
        ><br />{{ 'faq-search.post' | i18next }}
      </p>
    }
    @if (!!faqBodies?.length) {
      <mat-paginator
        color="primary"
        [length]="faqBodies.length"
        [hidePageSize]="true"
        [pageSize]="pageSize"
        [pageIndex]="index"
        (page)="goToPage($event)"></mat-paginator>
    }
  </div>
</div>
